import { z } from 'zod'

export const organizationUserAddRoleFormSchema = z.object({
  roleSlug: z
    .string()
    .min(1, 'organizationUsers:permissionsDialog.errors.roleRequired'),
})

export type OrganizationUserAddRoleFormData = z.infer<
  typeof organizationUserAddRoleFormSchema
>
